<template>
	<!-- 车辆管理 -->
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				<el-form-item v-if="bquery">
					<el-input v-model="filters.companyName" placeholder="企业名称"></el-input>
				</el-form-item>
        		<el-form-item>
					<el-input v-model="filters.carNo" placeholder="车牌号"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" v-on:click="companyCarList">查询</el-button>
				</el-form-item>
					<el-form-item v-if="bshow">
					<el-button type="success" v-on:click="handleAddbzhFile">新增车辆</el-button>
				</el-form-item>
				<el-form-item v-if="bquery">
					<el-button type="warning" @click="handledc" :loading="dcLoading">导出</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="datalist" highlight-current-row v-loading="listLoading"  style="width: 100%;">
			<el-table-column prop="carNo" label="车牌号" min-width="100" align="center">
			</el-table-column>

			<el-table-column prop="carType" label="车辆型号" align="center"  min-width="150">
			</el-table-column>

			<el-table-column prop="driveTypeName" label="驾驶类型" align="center"  min-width="100">
		 	</el-table-column>
			<el-table-column prop="transTypeName" label="运输类型" align="center"  min-width="100">
		 	</el-table-column>
			<el-table-column prop="energyTypeName" label="动力类型" align="center"  min-width="100">
		 	</el-table-column>

			<el-table-column prop="coName" label="所属企业"  align="center" min-width="200">
		 	</el-table-column>

			<el-table-column  v-if="bshow" label="操作"  align="left" width="250">
				<template slot-scope="scope">
					<el-button  type="danger" size="small" @click="handleCarDel(scope.$index, scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="total,prev, pager, next" @current-change="handleCurrentChange" :page-size="20" :total="total" style="float:right;">
			</el-pagination>
		</el-col>

		<!--新增-->
		<el-dialog title="新增车辆" v-model="fileFormVisible" :close-on-click-modal="false" >
			<el-form :label-position="labelPosition" :model="fileForm" label-width="120px" :rules="fileFormRules" ref="fileForm">
				
				<el-form-item label="车辆型号" prop="carType">
					<el-input placeholder="请输入车辆型号" v-model="fileForm.carType" auto-complete="off"></el-input>
				</el-form-item>

				<el-row>
					<el-col :span="11">
						<el-form-item label="车牌号" prop="carNo">
							<el-input placeholder="请输入车牌号" v-model="fileForm.carNo" auto-complete="off"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="11" :offset="2">      
						<el-form-item label="驾驶类型" >
							<el-select v-model="driveTypevalue" placeholder="请选择" >
								<el-option v-for="item in driveTypeoptions" :key="item.Mpid" :label="item.MpCn" :value="item.MpValue"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>

				<el-row>
					<el-col :span="11">
						<el-form-item label="运输类型" >
							<el-select v-model="transTypevalue" placeholder="请选择" >
								<el-option v-for="item in transTypeoptions" :key="item.Mpid" :label="item.MpCn" :value="item.MpValue"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="11" :offset="2">      
						<el-form-item label="动力类型" >
							<el-select v-model="energyTypevalue" placeholder="请选择" >
								<el-option v-for="item in energyTypeoptions" :key="item.Mpid" :label="item.MpCn" :value="item.MpValue"></el-option>
							</el-select>
						</el-form-item>	
					</el-col>
				</el-row>

			</el-form>
						
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="fileFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="handlefile" :loading="fileLoading">保存</el-button>
			</div>
		</el-dialog>


	</section>
</template>

<script>
	import axios from 'axios';
	import { companyCarPageList,companyCarPageListdc,addCompanyCar,deleteCompanyCar,getparamsByType} from '../../api/api';
	let moment = require("moment");
	export default {
		data() {
			return {
				objectId:0, //当前登录的用户id，新增会用到
				coId:0, //当前登录的用户企业id

				bquery:false,//管理员权限
				bshow:false,//是否显示操作按钮

				filters: {
					companyName: '',
					carNo:''
				},
				datalist: [],
				total: 0,
				page: 1,
				listLoading: false,

				driveTypeoptions: [],
				driveTypevalue:'',
				transTypeoptions: [],
				transTypevalue:'',
				energyTypeoptions: [],
				energyTypevalue:'',
			
				//新增
				labelPosition: 'right',

		

				fileFormVisible: false, 
				fileLoading: false,
				fileFormRules: {
					carNo: [{ required: true, message: "请输入车牌号", trigger: "blur" }],
					carType: [{ required: true, message: "请输入车辆型号", trigger: "blur" }],
				},
				
				fileForm: {
					createUserId:0,
					coId:0,

					carNo:"",
					carType:"",
					
					driveType:"",
					transType:"",
					energyType:"",
				},

				

				//要导出的数据list
				exportList: [],
				dcLoading: false
				//end

			}
		},
		methods: {
	
			handleAddbzhFile: function () {
				this.fileFormVisible = true;

				this.fileForm.createUserId=this.objectId
				this.fileForm.coId=this.coId

				this.fileForm.carNo=""
				this.fileForm.carType=""
				this.fileForm.driveType=""
				this.fileForm.transType=""
				this.fileForm.energyType=""				
			},
			
			handlefile: function () {

				this.$refs.fileForm.validate((valid) => {
					if (valid) {
						this.$confirm('确认保存车辆吗？', '提示', {}).then(() => {
						this.fileLoading = true;

						this.fileForm.driveType=this.driveTypevalue
						this.fileForm.transType=this.transTypevalue
						this.fileForm.energyType=this.energyTypevalue

						addCompanyCar(this.fileForm).then((res) => {
								this.fileLoading = false;

								this.fileFormVisible = false;
								if(res.data.code==0){
									this.$message.success(res.data.message);
									//更新列表
									this.companyCarList();
								}
								else{
									this.$message.error(res.data.message);
								}
							});
						});
					}
				});
			},	
			
			handleCarDel: function (index, row) {
				this.$confirm('确认删除这个车辆吗？', '提示', {}).then(() => {
					let deleteparam={
						carId:row.carId
					}
					deleteCompanyCar(deleteparam).then((res) => {
						if(res.data.code==0){
							this.$message.success(res.data.message);
							this.companyCarList();
						}
						else{
							this.$message.error(res.data.message);
						}
					});
				});	
			},

			handleCurrentChange(val) {				
				this.page = val;
				this.companyCarList();
			},
			//获取文件列表
			companyCarList() {
				let para = {
					page: this.page,
					pageSize:20,
					coName: this.filters.companyName,
					coId:this.coId,
					objectId:this.objectId,
					carNo: this.filters.carNo
				};

				this.listLoading = true;

				companyCarPageList(para).then((res) => {
					if(res.data.code==0){
						this.total = res.data.data.total;
						this.datalist = res.data.data.list;
					}
					
					this.listLoading = false;

				});
			},
			getCLJSLXdic() {
				let para={
					MpType:"CLJSLX",
					MpParentId:"205"
				}
				getparamsByType(para).then((res) => {
					if(res.data.code==0){
						this.driveTypeoptions  =res.data.data
						this.driveTypevalue=this.driveTypeoptions[0].MpValue
					}
				});
			},
			getCLYSLXdic() {
				let para={
					MpType:"CLYSLX",
					MpParentId:"208"
				}
				getparamsByType(para).then((res) => {
					if(res.data.code==0){
						this.transTypeoptions  =res.data.data
						this.transTypevalue=this.transTypeoptions[0].MpValue
					}
				});
			},
			getCLDLLXdic() {
				let para={
					MpType:"CLDLLX",
					MpParentId:"211"
				}
				getparamsByType(para).then((res) => {
					if(res.data.code==0){
						this.energyTypeoptions  =res.data.data
						this.energyTypevalue=this.energyTypeoptions[0].MpValue
					}
				});
			},
			//导出excel
			handledc: function() {

				this.$confirm('确认导出车辆表吗？', '提示', {}).then(() => {
					let para = {
						coName: this.filters.companyName,
						coId:this.coId,
						objectId:this.objectId,
						carNo: this.filters.carNo
					};

					this.dcLoading = true;

					companyCarPageListdc(para).then(res => {
						this.dcLoading = false;
						if (res.data.code == 0) {
							
							//将data数据赋给exportList这个列表，用于当作导出Excel的数据源							
							this.exportList =  res.data.data;

							//开始执行导出方法，此方法要放在括号里面，因为是异步请求数据，请求完才能执行导出
							this.export2Excel();
						} 
						else {
							this.$message.error(res.data.message);
						}
					});
					
				}).catch(() => {
  					// 用户点了取消 → 必须写 catch，否则控制台报错
					// this.$message.info('已取消');
				});			
			},

			export2Excel() {
			require.ensure([], () => {
				const { export_json_to_excel } = require("@/vendor/Export2Excel");

				const tHeader = [
				"所属企业",
				"车牌号",
				"车辆型号",
				"驾驶类型",
				"运输类型",
				"动力类型",
				];
   
				const filterVal = [
				"coName",
				"carNo",
				"carType",
				"driveTypeName",
				"transTypeName",
				"energyTypeName"
				];

				const list = this.exportList;

				const data = this.formatJson(filterVal, list);

				export_json_to_excel(
					tHeader,
					data,
					"车辆表_" + moment(new Date()).format("YYYYMMDDHHmmss")
				);
			});
			},

			formatJson(filterVal, jsonData) {
			return jsonData.map(v => filterVal.map(j => v[j]));
			},
		},
		mounted() {			
			let user = JSON.parse(sessionStorage.getItem('user'));

			this.coId = user.data.coId
			this.objectId = user.data.userId

			if (user.data.roleId=="4") {
				this.filters.companyName = user.data.userName	
				this.bshow=true
				this.bquery=false
			} else {
				this.bquery=true
				this.bshow=false
			}

			this.companyCarList();
			this.getCLJSLXdic();
			this.getCLYSLXdic();
			this.getCLDLLXdic();

		}
	}

</script>

<style scoped>
	
	
</style>


// WEBPACK FOOTER //
// enterpriseCar.vue?d83eefa8